import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["destroy"]

  toggleDestroy({ target: { checked } }) {
    this.destroyTarget.disabled = checked
  }
}
